import { SetURLSearchParams } from "react-router-dom";

export const setSearchParamsFilter = (
  updates: Record<string, string>,
  setSearchParams: SetURLSearchParams,
  resetPage = true,
) => {
  setSearchParams((prev) => {
    const next = Object.fromEntries(prev);

    for (const [key, value] of Object.entries(updates)) {
      if (value.trim() === "") {
        delete next[key];
      } else {
        next[key] = value;
      }
    }

    if (resetPage) next.page = "1";

    return next;
  });
};